<template>
  <div
    class="modal fade"
    id="shopperProfileModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form id="shopperProfileForm">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <h4 class="modal-title">
              <b>{{ lang.SP1001 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <div
              class="panel-group"
              id="accordion"
              role="tablist"
              aria-multiselectable="true"
            >
              <div class="panel panel-default">
                <!-- Accordion entry 1 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingGeneral"
                  :data-toggle="!globals.isMobileBrowser ? 'collapse' : ''"
                  data-parent="#accordion"
                  href="#collapseGeneral"
                  aria-expanded="true"
                  aria-controls="collapseGeneral"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.SP1002 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseGeneral"
                  class="panel-collapse collapse in"
                  role="tabpanel"
                  aria-labelledby="headingGeneral"
                >
                  <div class="panel-body">
                    <div
                      id="profilePictureContainer"
                      class="col-xs-8 col-md-3 col-xs-push-2 col-md-push-9"
                      @click="openFileSelector()"
                    >
                      <img
                        v-if="shopperProfileData.ProfilePictureGuid"
                        :src="
                          '/api/download/' +
                          shopperProfileData.ProfilePictureGuid
                        "
                      />
                      <img v-else src="/static/avatar.png" />
                      <input
                        id="inputShopperProfilePictureFile"
                        class="form-control hidden"
                        type="file"
                        accept="image/*"
                        @change="onShopperProfilePictureFileChange"
                        @click.stop
                      />
                      <a
                        role="button"
                        id="removeProfilePictureButton"
                        v-show="shopperProfileData.ProfilePictureGuid"
                        @click.stop="removeShopperProfilePictureFile()"
                      >
                        <i class="material-icons">clear</i>
                      </a>
                    </div>
                    <div class="form-group col-xs-12 col-md-9 col-md-pull-3">
                      <label
                        for="inputShopperSalutation"
                        class="col-md-4 control-label"
                        >{{ lang.SP1003 }}</label
                      >
                      <div class="col-md-8">
                        <select
                          class="form-control"
                          id="inputShopperSalutation"
                          v-model="shopperProfileData.Salutation"
                        >
                          <option value disabled hidden>
                            {{ lang.SP1004 }}
                          </option>
                          <option value="F">{{ lang.SP1005 }}</option>
                          <option value="M">{{ lang.SP1006 }}</option>
                        </select>
                      </div>
                    </div>
                    <div
                      class="
                        form-group
                        col-xs-12 col-md-9 col-md-pull-3
                        noclearfix
                      "
                    >
                      <label
                        for="inputShopperFirstName"
                        class="col-md-4 control-label"
                        >{{ lang.SP1010 }} *</label
                      >
                      <div class="col-md-8">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperFirstName"
                          v-model="shopperProfileData.FirstName"
                          @change="validateInput('inputShopperFirstName')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperFirstName')"
                          class="help-block error text-danger"
                          >{{ lang.SP1009 }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="
                        form-group
                        col-xs-12 col-md-9 col-md-pull-3
                        noclearfix
                      "
                    >
                      <label
                        for="inputShopperLastName"
                        class="col-md-4 control-label"
                        >{{ lang.SP1011 }} *</label
                      >
                      <div class="col-md-8">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperLastName"
                          v-model="shopperProfileData.LastName"
                          @change="validateInput('inputShopperLastName')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperLastName')"
                          class="help-block error text-danger"
                          >{{ lang.SP1009 }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="
                        form-group
                        col-xs-12 col-md-9 col-md-pull-3
                        noclearfix
                      "
                    >
                      <label
                        for="inputShopperGender"
                        class="col-md-4 control-label"
                        >{{ lang.SP1029 }} *</label
                      >
                      <div class="col-md-8">
                        <select
                          class="form-control"
                          id="inputShopperGender"
                          v-model="shopperProfileData.Gender"
                          @change="validateInput('inputShopperGender')"
                          required
                        >
                          <option value disabled hidden>
                            {{ lang.SP1004 }}
                          </option>
                          <option value="F">{{ lang.SP1031 }}</option>
                          <option value="M">{{ lang.SP1030 }}</option>
                          <option value="D">{{ lang.SP1033 }}</option>
                        </select>
                        <span
                          v-show="inputHasError('inputShopperGender')"
                          class="help-block error text-danger"
                          >{{ lang.SP1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group clearfix">
                      <label
                        for="inputShopperAddress1"
                        class="col-md-3 control-label"
                        >{{ lang.SP1012 }} *</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperAddress1"
                          v-model="shopperProfileData.Address1"
                          @change="validateInput('inputShopperAddress1')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperAddress1')"
                          class="help-block error text-danger"
                          >{{ lang.SP1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperPostalCode"
                        class="col-md-3 control-label"
                        >{{ lang.SP1013 }} *</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperPostalCode"
                          v-model="shopperProfileData.PostalCode"
                          @change="validateInput('inputShopperPostalCode')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperPostalCode')"
                          class="help-block error text-danger"
                          >{{ lang.SP1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperCity"
                        class="col-md-3 control-label"
                        >{{ lang.SP1014 }} *</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperCity"
                          v-model="shopperProfileData.City"
                          @change="validateInput('inputShopperCity')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperCity')"
                          class="help-block error text-danger"
                          >{{ lang.SP1009 }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="Object.keys(globals.countryList).length > 0"
                    >
                      <label
                        for="inputShopperCountryCode"
                        class="col-md-3 control-label"
                        >{{ lang.SP1015 }} *</label
                      >
                      <div class="col-md-9">
                        <select2
                          v-if="!globals.isMobileBrowser"
                          class="form-control"
                          id="inputShopperCountryCode"
                          v-model="shopperProfileData.CountryCode"
                          :placeholder="lang.SP1004"
                          @change="
                            validateInput('inputShopperCountryCode'),
                              delete shopperProfileData.SocialSecurityNumber
                          "
                          required
                        >
                          <option></option>
                          <option
                            v-for="(country, ISOCode) in globals.countryList"
                            :key="ISOCode"
                            :value="ISOCode"
                          >
                            {{ country }}
                          </option>
                        </select2>
                        <select
                          v-else
                          class="form-control"
                          id="inputShopperCountryCode"
                          v-model="shopperProfileData.CountryCode"
                          @change="
                            validateInput('inputShopperCountryCode'),
                              delete shopperProfileData.SocialSecurityNumber
                          "
                          required
                        >
                          <option
                            v-for="(country, ISOCode) in globals.countryList"
                            :key="ISOCode"
                            :value="ISOCode"
                          >
                            {{ country }}
                          </option>
                        </select>
                      </div>
                      <span
                        v-show="inputHasError('inputShopperCountryCode')"
                        class="help-block error text-danger"
                        >{{ lang.SP1009 }}</span
                      >
                    </div>
                    <!-- Region depending on country  -->
                    <div
                      class="form-group"
                      v-if="regionsOfSelectedCountry.length > 0"
                    >
                      <label
                        for="inputShopperRegionGuid"
                        class="col-md-3 control-label"
                        >{{ lang.SP1049 }} *</label
                      >
                      <div class="col-md-9">
                        <select2
                          v-if="!globals.isMobileBrowser"
                          class="form-control"
                          id="inputShopperRegionGuid"
                          ref="inputShopperRegionGuid"
                          v-model="shopperProfileData.RegionGuid"
                          :placeholder="lang.SP1004"
                          @change="validateInput('inputShopperRegionGuid')"
                          required
                          :disabled="!shopperProfileData.CountryCode"
                        >
                          <option></option>
                          <option
                            v-for="region in regionsOfSelectedCountry"
                            :key="region.RegionGuid"
                            :value="region.RegionGuid"
                          >
                            {{ region.RegionName }}
                          </option>
                        </select2>
                        <select
                          v-else
                          class="form-control"
                          id="inputShopperRegionGuid"
                          v-model="shopperProfileData.RegionGuid"
                          @change="validateInput('inputShopperRegionGuid')"
                          required
                          :disabled="!shopperProfileData.CountryCode"
                        >
                          <option
                            v-for="region in regionsOfSelectedCountry"
                            :key="region.RegionGuid"
                            :value="region.RegionGuid"
                          >
                            {{ region.RegionName }}
                          </option>
                        </select>
                      </div>
                      <span
                        v-show="inputHasError('inputShopperRegionGuid')"
                        class="help-block error text-danger"
                        >{{ lang.SP1009 }}</span
                      >
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperBirthdate"
                        class="col-md-3 control-label"
                        >{{ lang.SP1016 }} *</label
                      >
                      <div
                        class="col-md-9"
                        @click="
                          globals.toggleFlatpickr('inputShopperBirthdate')
                        "
                      >
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperBirthdate"
                          v-model="shopperProfileData.Birthdate"
                          @change="validateInput('inputShopperBirthdate')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperBirthdate')"
                          class="help-block error text-danger"
                          >{{ lang.SP1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperEmail"
                        class="col-md-3 control-label"
                        >{{ lang.SP1017 }} *</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperEmail"
                          v-model="shopperProfileData.Email"
                          @change="validateInput('inputShopperEmail')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperEmail')"
                          class="help-block error text-danger"
                          >{{ lang.SP1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperPhone1"
                        class="col-md-3 control-label"
                        >{{ lang.SP1018 }} *</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperPhone1"
                          v-model="shopperProfileData.Phone1"
                          @change="validateInput('inputShopperPhone1')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperPhone1')"
                          class="help-block error text-danger"
                          >{{ lang.SP1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperPhone2"
                        class="col-md-3 control-label"
                        >{{ lang.SP1019 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperPhone2"
                          v-model="shopperProfileData.Phone2"
                        />
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        Object.keys(globals.occupationalGroupList).length > 0
                      "
                    >
                      <label
                        for="inputShopperOccupationGroup"
                        class="col-md-3 control-label"
                        >{{ lang.SP1020 }} *</label
                      >
                      <div class="col-md-9">
                        <select2
                          v-if="!globals.isMobileBrowser"
                          class="form-control"
                          id="inputShopperOccupationGroup"
                          v-model="shopperProfileData.OccupationalGroupGuid"
                          :placeholder="lang.SP1004"
                          @change="validateInput('inputShopperOccupationGroup')"
                          required
                        >
                          <option></option>
                          <option
                            v-for="(
                              occupationGroup, occupationGroupGuid
                            ) in occupationalGroupList"
                            :key="occupationGroupGuid"
                            :value="occupationGroupGuid"
                          >
                            {{ occupationGroup }}
                          </option>
                        </select2>
                        <select
                          v-else
                          class="form-control"
                          id="inputShopperOccupationGroup"
                          v-model="shopperProfileData.OccupationalGroupGuid"
                          @change="validateInput('inputShopperOccupationGroup')"
                          required
                        >
                          <option
                            v-for="(
                              occupationGroup, occupationGroupGuid
                            ) in occupationalGroupList"
                            :key="occupationGroupGuid"
                            :value="occupationGroupGuid"
                          >
                            {{ occupationGroup }}
                          </option>
                        </select>
                      </div>
                      <span
                        v-show="inputHasError('inputShopperOccupationGroup')"
                        class="help-block error text-danger"
                        >{{ lang.SP1009 }}</span
                      >
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperOccupation"
                        class="col-md-3 control-label"
                        >{{ lang.SP1021 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperOccupation"
                          v-model="shopperProfileData.Occupation"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperEmployer"
                        class="col-md-3 control-label"
                        >{{ lang.SP1022 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperEmployer"
                          v-model="shopperProfileData.Employer"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperVatNo"
                        class="col-md-3 control-label"
                        >{{ lang.SP1032 }} *</label
                      >
                      <div class="col-md-4">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperVatNo"
                          :disabled="shopperProfileData.VatNotMandatory"
                          v-model="shopperProfileData.VatNo"
                          @change="validateInput('inputShopperVatNo')"
                          :required="!shopperProfileData.VatNotMandatory"
                        />
                        <span
                          v-show="inputHasError('inputShopperVatNo')"
                          class="help-block error text-danger"
                          >{{ lang.SP1009 }}</span
                        >
                      </div>
                      <div class="col-md-5">
                        <div class="checkbox" style="float: left">
                          <label>
                            <input
                              type="checkbox"
                              v-model="shopperProfileData.VatNotMandatory"
                              @change="vatNotMandatoryChanged()"
                            />
                            <span class="checkbox-material">
                              <span class="check"></span>
                            </span>
                            <span class="text text-black">{{
                              lang.SP1045
                            }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="shopperProfileData.CountryCode === 'AT'"
                    >
                      <label
                        for="inputShopperSocialSecurityNumber"
                        class="col-md-3 control-label"
                        >{{ lang.SP1046 }} *</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperSocialSecurityNumber"
                          v-model="shopperProfileData.SocialSecurityNumber"
                          @change="
                            validateInput('inputShopperSocialSecurityNumber')
                          "
                          required
                        />
                        <span
                          v-show="
                            inputHasError('inputShopperSocialSecurityNumber')
                          "
                          class="help-block error text-danger"
                          >{{ lang.SP1009 }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Accordion entry 2 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingBankDetails"
                  :data-toggle="!globals.isMobileBrowser ? 'collapse' : ''"
                  data-parent="#accordion"
                  href="#collapseBankDetails"
                  aria-expanded="true"
                  aria-controls="collapseBankDetails"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.SP1000 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseBankDetails"
                  class="panel-collapse collapse"
                  :class="{ in: globals.isMobileBrowser }"
                  role="tabpanel"
                  aria-labelledby="headingBankDetails"
                >
                  <div class="panel-body">
                    <div class="form-group">
                      <label
                        for="inputBankDetailsBankName"
                        class="col-md-3 control-label"
                        >{{ lang.SP1023 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputBankDetailsBankName"
                          v-model="bankDetailsData.BankName"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputBankDetailsSwiftCode"
                        class="col-md-3 control-label"
                        >{{ lang.SP1034 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputBankDetailsSwiftCode"
                          v-model="bankDetailsData.SwiftCode"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputBankDetailsAccountNumber"
                        class="col-md-3 control-label"
                        >{{ lang.SP1035 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputBankDetailsAccountNumber"
                          v-model="bankDetailsData.AccountNumber"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputBankDetailsAccountName"
                        class="col-md-3 control-label"
                        >{{ lang.SP1036 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputBankDetailsAccountName"
                          v-model="bankDetailsData.AccountName"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="panel-heading"
                  role="button"
                  id="headingCustomProperties"
                  :data-toggle="!globals.isMobileBrowser ? 'collapse' : ''"
                  data-parent="#accordion"
                  href="#collapseCustomProperties"
                  aria-expanded="true"
                  aria-controls="collapseCustomProperties"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.SP1044 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseCustomProperties"
                  class="panel-collapse collapse"
                  :class="{ in: globals.isMobileBrowser }"
                  role="tabpanel"
                  aria-labelledby="headingCustomProperties"
                >
                  <div class="panel-body">
                    <custom-properties-form
                      ref="customPropertiesForm"
                    ></custom-properties-form>
                  </div>
                </div>
                <div id="scrollOverflowBlock"></div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.SP1007 }}
            </button>
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="validateBeforeSubmit('shopperProfileModal')"
            >
              {{ lang.SP1008 }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";
import CustomPropertiesForm from "./CustomPropertiesForm";

const ibantools = require("ibantools");

export default {
  name: "ShopperProfileModal",
  components: {
    Select2,
    CustomPropertiesForm,
  },
  mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getOccupationalGroupList((callbackData) => {
        this.occupationalGroupList = callbackData;
      });
      this.globals.getCountryList();
      this.globals.getRegionsList((data) => (this.regions = data));
      this.fpBirthdate = flatpickr(
        "#inputShopperBirthdate",
        this.globals.flatpickrDateConfig
      );
    }

    $("#shopperProfileModal").on("hide.bs.modal", (e) => {
      this.$emit("modalClosed");
    });

    if (this.globals.isMobileBrowser && !this.globals.isSafariBrowser) {
      $('#shopperProfileModal input[type="text"]').on("focus", function () {
        // Timeout to wait for keyboard
        setTimeout(() => {
          this.parentNode.parentNode.scrollIntoView({ behavior: "smooth" });
        }, 500);
      });
    }
  },
  destroyed() {
    if (this.fpBirthdate) this.fpBirthdate.destroy();
  },
  props: ["showDialog"],
  computed: {
    regionsOfSelectedCountry() {
      if (!this.shopperProfileData.CountryCode) return [];
      let resultObj = this.regions.filter(
        (country) => country.CountryCode === this.shopperProfileData.CountryCode
      );
      let regions = (resultObj[0] && resultObj[0].Regions) || [];

      if (
        this.shopperProfileData.RegionGuid &&
        _.findIndex(
          regions,
          (r) => r.RegionGuid === this.shopperProfileData.RegionGuid
        ) < 0
      )
        this.shopperProfileData.RegionGuid = "";

      return regions;
    },
  },
  watch: {
    showDialog(newVal) {
      newVal ? this.openEditShopperDialog() : this.closeEditShopperDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
      this.globals.getRegionsList((data) => (this.regions = data));
      this.globals.getOccupationalGroupList((callbackData) => {
        this.occupationalGroupList = callbackData;
      });

      if (this.fpBirthdate) this.fpBirthdate.destroy();
      this.$nextTick(() => {
        this.fpBirthdate = flatpickr(
          "#inputShopperBirthdate",
          this.globals.flatpickrDateConfig
        );
      });
    },
  },
  data() {
    return {
      invalidInputIds: [],
      fpBirthdate: null,
      profilePictureFileObject: {},
      occupationalGroupList: {},
      shopperPicture: {
        fileGuid: "",
        fileName: "",
      },
      regions: [],
      shopperProfileData: {
        Salutation: "",
        FirstName: "",
        LastName: "",
        Address1: "",
        PostalCode: "",
        City: "",
        CountryCode: "",
        RegionGuid: "",
        Birthdate: "",
        Email: "",
        Phone1: "",
        Phone2: "",
        OccupationalGroupGuid: "", // Berufsgruppe
        Occupation: "", // Tätig als
        Employer: "", // Tätig bei
        Gender: "",
        VatNo: "",
        ProfilePictureGuid: "",
      },
      bankDetailsData: {},
      // shopperProperties: {},
      propertiesFormData: {},
      lang: {
        SP1000: "Bank Details",
        SP1001: "User Profile",
        SP1002: "General",
        SP1003: "Salutation", // form of adress
        SP1004: "Please select...",
        SP1005: "Madam",
        SP1006: "Monsieur",
        SP1007: "Close",
        SP1008: "Save",
        SP1009: "This is a required entry!",
        SP1010: "First name",
        SP1011: "Last name",
        SP1012: "Street",
        SP1013: "Postal Code",
        SP1014: "City",
        SP1015: "Country",
        SP1016: "Birthday",
        SP1017: "Email",
        SP1018: "Phone",
        SP1019: "Alternative Phone",
        SP1020: "Career",
        SP1021: "Active as",
        SP1022: "Active by",
        SP1023: "Bank name",
        SP1024: "Picture",
        SP1025: "Please choose a picture...",
        SP1026: "Choose picture",
        SP1027: "Download picture",
        SP1028: "Delete picture",
        SP1029: "Gender",
        SP1030: "Male",
        SP1031: "Female",
        SP1032: "VAT No.",
        SP1033: "Divers",
        SP1034: "BIC",
        SP1035: "IBAN",
        SP1036: "Account owner",
        SP1037: "Form validation failed",
        SP1038: "Profile data request failed",
        SP1039: "Profile data update successful",
        SP1040: "Profile data update failed",
        SP1041: "Invalid file type",
        SP1042: "Upload successful",
        SP1043: "Upload failed",
        SP1044: "Profile information",
        SP1045: "VAT not mandatory",
        SP1046: "Social security number",
        SP1047: "Invalid IBAN",
        SP1048: "Invalid BIC",
        SP1049: "Region",
      },
    };
  },
  methods: {
    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit(dialog) {
      var result = true;
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }
      if (dialog === "shopperProfileModal") {
        if (!result) {
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SP1037, colorOrange: false});
          return;
        }
        this.saveProfileData();
      }
    },
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput(id) {
      // Checks validation depending on the input type or a given pattern in the template
      var result =
        id === "inputShopperBirthday"
          ? $("#" + id)[0].value !== ""
          : $("#" + id)[0].checkValidity();
      if (result) {
        $("#" + id)
          .parent()
          .parent()
          .removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id)
          .parent()
          .parent()
          .addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },
    // Returns true if an input has a validation error, otherwise false
    inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },
    // Resets all validation errors for the given dialog
    resetValidationErrors(dialog) {
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          $("#" + elements[i].id)
            .parent()
            .parent()
            .removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    openEditShopperDialog() {
      let requestCount = 3;
      let successCallback = () => {
        if (--requestCount < 1) {
          $("#shopperProfileModal").modal("show");
          this.resetValidationErrors("shopperProfileModal");
        }
      };
      let errorCallback = () => {
        this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SP1038, colorOrange: false});
        this.$emit("modalClosed");
      };
      this.getProfileData(successCallback, errorCallback);
      this.getBankDetails(successCallback, errorCallback);
      this.$refs.customPropertiesForm.getShopperProperties(
        successCallback,
        errorCallback
      );
    },
    closeEditShopperDialog() {
      $("#shopperProfileModal").modal("hide");
    },
    vatNotMandatoryChanged() {
      delete this.shopperProfileData.VatNo;
      this.$nextTick(() => {
        this.validateInput("inputShopperVatNo");
      });
    },
    getProfileData(success, error) {
      let queryString = `shopper-api/Profile`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.shopperProfileData = data;
          if (this.shopperProfileData.Birthdate)
            this.fpBirthdate.setDate(this.shopperProfileData.Birthdate);
          if (this.$refs.inputShopperRegionGuid)
            this.$refs.inputShopperRegionGuid.updateValue();
          success();
        },
        error: () => {
          console.error("Error on GET in getProfileData()");
          error();
        },
      });
    },
    saveProfileData() {
      if (!this.validateBankDetails()) return;

      let requestCount = 3;
      let successCallback = () => {
        if (--requestCount < 1) {
          this.globals.showSuccessSnackbar(this.lang.SP1039);
          this.closeEditShopperDialog();
          this.$emit("dialogDataSaved");
        }
      };
      let errorCallback = () => {
        this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SP1040, colorOrange: false});
      };

      this.saveBankDetails(successCallback, errorCallback);
      this.$refs.customPropertiesForm.saveShopperProperties(
        successCallback,
        errorCallback
      );

      let queryString = "shopper-api/Profile";
      if (!this.shopperProfileData.ProfilePictureGuid)
        delete this.shopperProfileData.ProfilePictureGuid;
      if (!this.shopperProfileData.RegionGuid)
        delete this.shopperProfileData.RegionGuid;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: JSON.stringify(this.shopperProfileData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          successCallback();
        },
        error: () => {
          console.error("Error on PUT in saveProfileData()");
          errorCallback();
        },
      });
    },
    onShopperProfilePictureFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) {
        this.shopperProfileData.ProfilePictureGuid = "";
        this.profilePictureFileObject = {};
        return;
      }
      this.profilePictureFileObject = files[0];
      if (this.profilePictureFileObject.type.indexOf("image/") < 0) {
        this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SP1041, colorOrange: false});
        e.target.value = null;
        return;
      }

      let callback = () => {
        let uploadSuccess = (data) => {
          this.shopperProfileData.ProfilePictureGuid = data[0].DownloadId;
          this.shopperProfileData.ProfilePictureName =
            this.profilePictureFileObject.name;
          this.globals.showSuccessSnackbar(this.lang.SP1042);
          this.$forceUpdate();
        };

        this.globals.uploadFile(
          this.profilePictureFileObject,
          false,
          uploadSuccess
          // () => this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SP1043, colorOrange: false});
        );
        e.target.value = null;
      };

      this.profilePictureFileObject.imageUrl = URL.createObjectURL(
        this.profilePictureFileObject
      );
      callback();
    },
    removeShopperProfilePictureFile() {
      $("#inputShopperProfilePictureFile")[0].value = null;
      this.shopperProfileData.ProfilePictureGuid = "";
      this.shopperProfileData.ProfilePictureName = "";
      this.profilePictureFileObject = {};
      this.$forceUpdate();
    },
    getBankDetails(success, error) {
      let queryString = `shopper-api/Profile/BankDetails`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data) {
            if (!_.isEmpty(data)) {
              this.bankDetailsData = data[0];
            } else {
              this.bankDetailsData = {};
            }
            success();
          } else error();
        },
        error: () => {
          console.error("Error on GET in getBankDetails()");
          this.bankDetailsData = {};
          error();
        },
      });
    },
    saveBankDetails(success, error) {
      let queryString = "shopper-api/Profile/BankDetails";
      let reqMethod = "POST";
      if (this.bankDetailsData.BankDetailsGuid) {
        queryString += "/" + this.bankDetailsData.BankDetailsGuid;
        reqMethod = "PUT";
      }

      $.ajax({
        method: reqMethod,
        url: queryString,
        data: JSON.stringify(this.bankDetailsData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data && !_.isEmpty(data)) {
            this.bankDetailsData = data;
          }
          success();
        },
        error: () => {
          console.error("Error on PUT in saveProfileData()");
          error();
        },
      });
    },
    validateBankDetails() {
      if (this.bankDetailsData.AccountNumber) {
        this.bankDetailsData.AccountNumber =
          this.bankDetailsData.AccountNumber.replace(/ /g, "");
        if (!ibantools.isValidIBAN(this.bankDetailsData.AccountNumber)) {
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SP1047, colorOrange: false});
          return false;
        }
      }
      if (this.bankDetailsData.SwiftCode) {
        this.bankDetailsData.SwiftCode = this.bankDetailsData.SwiftCode.replace(
          / /g,
          ""
        );
        if (!ibantools.isValidBIC(this.bankDetailsData.SwiftCode)) {
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SP1048, colorOrange: false});
          return false;
        }
      }
      return true;
    },
    openFileSelector() {
      $("#inputShopperProfilePictureFile").click();
    },
  },
};
</script>

<style scoped>
.form-group-files {
  padding: 2px 0;
  overflow: hidden;
}

#profilePictureContainer > img {
  height: 180px;
  width: 180px;
  object-fit: contain;
  cursor: pointer;
}

#removeProfilePictureButton {
  position: absolute;
  top: 0px;
  right: 0px;
  color: rgb(224, 0, 0);
  background: white;
  opacity: 0.7;
  width: 36px;
  height: 36px;
  border-radius: 18px;
  text-decoration: none;
}
#removeProfilePictureButton > i {
  font-size: 36px;
  font-weight: bold;
}

#scrollOverflowBlock {
  height: 60vh;
  display: none;
}

.noclearfix {
  clear: none !important;
}

#collapseGeneral .form-group {
  overflow: hidden;
}

@supports not (-moz-appearance: none) {
  @media (min-width: 1001px) {
    #collapseGeneral .checkbox .text {
      position: relative;
      top: 2px;
      left: 2px;
    }
  }
}
@supports (-moz-appearance: none) {
  #collapseGeneral .form-group {
    overflow: visible;
  }
}

.panel-heading > .panel-title > a.collapsed {
  text-decoration: none;
  color: inherit;
}

@media (max-width: 1000px) {
  #profilePictureContainer > img {
    height: 30vw;
    width: 30vw;
  }

  #removeProfilePictureButton {
    width: 2em;
    height: 2em;
    border-radius: 1em;
  }
  #removeProfilePictureButton > i {
    font-size: 2em;
  }
  /* Overwrite some rules for portrait mode */
  @media screen and (max-aspect-ratio: 13/9) {
    #profilePictureContainer > img {
      height: 50vw;
      width: 50vw;
    }

    #shopperProfileModal > .modal-dialog {
      width: 100vw;
      margin: 0;
    }

    #shopperProfileModal > .modal-dialog .modal-footer {
      position: sticky;
      bottom: 0;
      left: 0;
      right: 0;
      background: lightgray;
      z-index: 1000;
    }

    #removeProfilePictureButton {
      width: 3em;
      height: 3em;
      border-radius: 1.5em;
    }
    #removeProfilePictureButton > i {
      font-size: 3em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ShopperProfile.vue?12b487f1